import { SaleNoteStatusReport } from '../../../../../core';

export const saleNoteStatusReport = {
    searchText: '',
    sort: true,
    dialogHability: true,
    filter: false,
    paginator: true,
    checkbox: false,
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Número de N/V',
        name: 'orderNumber',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.nvCode
      },
      {
        title: 'Fecha generaci\u00F3n',
        name: 'generatedDate',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'center w120',
        value: (element: SaleNoteStatusReport) => element.saleDate
      },
      {
        title: 'Cliente',
        name: 'customer',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.customerLastName + ' ' + element.customerFirstName
      },
      {
        title: 'Tipo Doc.',
        name: 'documentType',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: false,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.documentType
      },
      {
        title: 'Nro. Doc',
        name: 'identityDocument',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.customerDocument
      },
      {
        title: 'Telf. cliente',
        name: 'contactPhone',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.contactPhone
      },
      {
        title: 'Código Vtex',
        name: 'ecommerceId',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.ecommerceId
      },
      {
        title: 'Correo cliente',
        name: 'contactEmail',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: false,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.contactEmail
      },
      {
        title: 'Entidad de venta',
        name: 'saleEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.saleLocationName
      },
      {
        title: 'Usuario de Autor.',
        name: 'priceAuthUsername',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: false,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.priceEditUsername
      },
      {
        title: 'Monto total',
        name: 'totalAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: true,
        class: 'right',
        value: (element: SaleNoteStatusReport) => element.totalAmount
      },
      {
        title: 'Vendedor',
        name: 'username',
        type: 'string',
        editable: false,
        checkAll: false,
        visible: false,
        class: 'left',
        value: (element: SaleNoteStatusReport) => element.paymentOrder.saleUser
      },
      {
        title: 'Cantidad solicitada',
        name: 'requestAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.requestAmountNv
      },
      {
        title: 'Candidad de SKUs solicitados',
        name: 'requestSkuAmount',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.requestAmountSkuNv
      },
      {
        title: 'Estatus de N/V',
        name: 'nvState',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.state.stateName
      },
      {
        title: 'Fecha de entrega comprometida',
        name: 'committedDeliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.committedDeliveryDate
      },
      /* {
        title: 'Fecha de entrega estimada',
        name: 'estimatedDeliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.estimatedDeliveryDate
      }, */
      {
        title: 'Fecha real de entrega',
        name: 'actualDeliveryDate',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: SaleNoteStatusReport) => element.dispatchDate ? element.dispatchDate : element.actualDeliveryDate
      }
    ]
  };
